// extracted by mini-css-extract-plugin
module.exports = {"transactionsCtaContainer":"DynamicLinkList_transactionsCtaContainer__2FsDw","headerContainer":"DynamicLinkList_headerContainer__11OAb","backBtn":"DynamicLinkList_backBtn__qNKap"};